// src/components/Analytics.tsx

import { useAPI } from '../hooks/useAPI';
import { api } from '../services/api';
import type { UsageStats, ConversationStats } from '../types';

export function Analytics() {
  const usageStats = useAPI<UsageStats>(
    () => api.getUsageStats('month'),
    [],
    'usage-stats-month'
  );
  const conversationStats = useAPI<ConversationStats>(
    () => api.getConversationStats(),
    [],
    'conversation-stats'
  );

  if (usageStats.loading || conversationStats.loading) {
    return <div className="p-4">Loading analytics...</div>;
  }

  const usage = usageStats.data;
  const conversations = conversationStats.data;

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold">Analytics</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <div className="bg-white p-6 rounded-lg shadow">
          <h3 className="text-sm font-medium text-gray-500">DMs Sent Today</h3>
          <p className="text-3xl font-bold mt-2">{usage?.dms_today || 0}</p>
          <p className="text-sm text-gray-500 mt-1">
            of {usage?.limit || 0} daily limit
          </p>
        </div>

        <div className="bg-white p-6 rounded-lg shadow">
          <h3 className="text-sm font-medium text-gray-500">Remaining Today</h3>
          <p className="text-3xl font-bold mt-2">{usage?.remaining_today || 0}</p>
        </div>

        <div className="bg-white p-6 rounded-lg shadow">
          <h3 className="text-sm font-medium text-gray-500">Total Conversations</h3>
          <p className="text-3xl font-bold mt-2">{conversations?.total_conversations || 0}</p>
        </div>

        <div className="bg-white p-6 rounded-lg shadow">
          <h3 className="text-sm font-medium text-gray-500">Gemini Tokens Used</h3>
          <p className="text-3xl font-bold mt-2">{usage?.gemini_tokens_used || 0}</p>
        </div>
      </div>

      <div className="bg-white p-6 rounded-lg shadow">
        <h3 className="text-lg font-semibold mb-4">Usage Progress</h3>
        <div className="w-full bg-gray-200 rounded-full h-4">
          <div
            className="bg-blue-600 h-4 rounded-full transition-all"
            style={{ width: `${usage?.usage_percentage || 0}%` }}
          />
        </div>
        <p className="text-sm text-gray-500 mt-2">
          {usage?.usage_percentage || 0}% of daily limit used
        </p>
      </div>
    </div>
  );
}
